import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { Body, SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';
import PopoverButton from 'talent_matching/components/filters/popover_button';
import { useRediscoveryTabContext } from 'talent_matching/contexts/rediscovery_tab_context';
import RejectionReasonsDropdown from './rejection_reasons_dropdown';
import ExcludeTagsDropdown from './exclude_tags_dropdown';
import ExcludeHiredCheckbox from 'talent_search/components/checkboxes/exclude_hired_checkbox';
import ExcludeStrongNoScoresCheckbox from 'talent_search/components/checkboxes/exclude_strong_no_scores_checkbox';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row');

const REDISCOVERY_PAGE_NAME = 'rediscovery' as const;

const ExclusionFiltersGroup = () => {
  const { apiClient } = useRediscoveryTabContext();
  const { watch, setValue } = useFormContext();
  const [
    excludeRejectionReasons,
    withoutCandidateTags,
    excludeHired,
    excludeStrongNoScores,
  ] = watch([
    'exclude_rejection_reasons',
    'without_candidate_tags',
    'exclude_hired',
    'no_strong_no_scores',
  ]);

  const hasExcludeRejectionReasons =
    Array.isArray(excludeRejectionReasons) &&
    excludeRejectionReasons.length > 0;
  const hasWithoutCandidateTags =
    Array.isArray(withoutCandidateTags) && withoutCandidateTags.length > 0;

  const appliedCount = [
    hasExcludeRejectionReasons,
    hasWithoutCandidateTags,
    excludeHired,
    excludeStrongNoScores,
  ].filter(Boolean).length;

  const clear = () => {
    setValue('exclude_rejection_reasons', [], { shouldDirty: true });
    setValue('without_candidate_tags', [], { shouldDirty: true });
    setValue('exclude_hired', false, { shouldDirty: true });
    setValue('no_strong_no_scores', false, { shouldDirty: true });
  };

  const buttonLabel = `${t('exclusions.button')}${
    appliedCount ? ` (${appliedCount})` : ''
  }`;

  return (
    <PopoverButton
      buttonLabel={buttonLabel}
      title={t('exclusions.title')}
      width="640px"
    >
      <Stack spacing={3}>
        <Body>{t('exclusions.description')}</Body>
        <RejectionReasonsDropdown
          fetchRejectionReasons={apiClient.fetchRejectionReasons}
          type="exclude"
          helperText={t('exclusions.exclude_rejection_reasons_helper_text')}
        />

        <ExcludeTagsDropdown />

        <Stack spacing={2}>
          <SecondaryBody medium>
            {t('exclusions.global_exclusions_header')}
          </SecondaryBody>
          <Stack spacing={1}>
            <ExcludeHiredCheckbox pageName={REDISCOVERY_PAGE_NAME} />
            <ExcludeStrongNoScoresCheckbox pageName={REDISCOVERY_PAGE_NAME} />
          </Stack>
        </Stack>

        <Stack sx={{ alignSelf: 'flex-start' }}>
          <TertiaryButton onClick={clear} size="lg">
            {t('clear')}
          </TertiaryButton>
        </Stack>
      </Stack>
    </PopoverButton>
  );
};

export default ExclusionFiltersGroup;
